module.exports = __webpack_public_path__ + "MW.png?ce384b71a2c5b78ea69a87e924607a28";